// @file The store for surface onboarding panel displayed by surface_app.vue
import { captureFetchException } from '@@/bits/error_tracker'
import window from '@@/bits/global'
import { defineStore } from 'pinia'
import { useWindowSizeStore } from 'pinia/window_size'
import PadletApi from 'surface/padlet_api'
import { computed, ref } from 'vue'

const PANEL_SIZE_DESKTOP = 480
const PANEL_SIZE_SMALLER_THAN_DESKTOP = 400

export const useSurfaceOnboardingPanelStore = defineStore('surfaceOnboardingPanel', () => {
  const isSmallerThanDesktop = computed(() => useWindowSizeStore().isSmallerThanDesktop)
  // State
  const initialOnboardingPanelState = computed(() => window.app?.$store.getters.showOnboardingPanel)
  const hasOnboardingCompleted = ref(false)

  // Getters

  // Even though this value is read in as a string, we'll treat it as a boolean to make conditional rendering easier
  const showOnboardingPanel = computed(
    () => initialOnboardingPanelState.value === true && !hasOnboardingCompleted.value,
  )

  const panelWidth = computed(() => {
    if (!showOnboardingPanel.value) return 0
    return isSmallerThanDesktop.value ? PANEL_SIZE_SMALLER_THAN_DESKTOP : PANEL_SIZE_DESKTOP
  })

  // Actions

  function closeOnboardingPanel(): void {
    void fetchWallOnboardingPanelHide()
    hasOnboardingCompleted.value = true
  }

  async function fetchWallOnboardingPanelHide(): Promise<void> {
    try {
      await PadletApi.WallOnboardingPanel.fetch(window.app?.$store.getters?.wallId)
    } catch (e) {
      captureFetchException(e, { source: ' SurfaceWallOnboardingPanelHide' })
    }
  }

  return {
    // Getter
    showOnboardingPanel,
    panelWidth,

    // Actions,
    closeOnboardingPanel,
  }
})
